import React from "react";
import { Quill } from "react-quill";

// Import Parchment
const Parchment = Quill.import("parchment");

// Register custom styles (e.g., padding) with Parchment
const PaddingStyle = new Parchment.Attributor.Style("padding", "padding", {
  scope: Parchment.Scope.INLINE,
});
Parchment.register(PaddingStyle);

// Extend ImageBlot to preserve attributes and styles
const ImageBlot = Quill.import("formats/image");

class StyledImage extends ImageBlot {
  static create(value) {
    const node = super.create(value);
    if (typeof value === "object") {
      Object.keys(value).forEach((key) => {
        node.setAttribute(key, value[key]);
      });
    }
    return node;
  }

  static formats(domNode) {
    const formats = super.formats(domNode) || {};
    domNode.getAttributeNames().forEach((name) => {
      formats[name] = domNode.getAttribute(name);
    });
    return formats;
  }

  format(name, value) {
    if (value) {
      this.domNode.setAttribute(name, value);
    } else {
      this.domNode.removeAttribute(name);
    }
  }
}

// Register the custom ImageBlot
StyledImage.blotName = "image";
StyledImage.tagName = "img";
Quill.register(StyledImage, true);
////

//
// Import Quill's attributors for inline styles
const AlignStyle = Quill.import("attributors/style/align");
const ColorStyle = Quill.import("attributors/style/color");
const BackgroundStyle = Quill.import("attributors/style/background");
const FontStyle = Quill.import("attributors/style/font");
const SizeStyle = Quill.import("attributors/style/size");

// Register them to use inline styles
Quill.register(AlignStyle, true);
Quill.register(ColorStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

// Add custom whitelist for fonts and sizes
const Size = Quill.import("formats/size");
Size.whitelist = ["10px", "12px", "14px", "16px", "18px", "20px"];
Quill.register(Size, true);

const Font = Quill.import("formats/font");
Font.whitelist = ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida"];
Quill.register(Font, true);
//

// Modules object for setting up the Quill editor
export const modules = {
  toolbar: {
    container: "#toolbar",
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
};

// Formats objects for setting up the Quill editor
export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "code-block"
];

// Quill Toolbar component
export const QuillToolbar = () => (
  <div id="toolbar">
    <span className="ql-formats">
      <select className="ql-font" defaultValue="arial">
        <option value="arial">Arial</option>
        <option value="comic-sans">Comic Sans</option>
        <option value="courier-new">Courier New</option>
        <option value="georgia">Georgia</option>
        <option value="helvetica">Helvetica</option>
        <option value="lucida">Lucida</option>
      </select>
      <select className="ql-size" defaultValue="medium">
        <option value="10px">10</option>
        <option value="12px">12</option>
        <option value="14px">14</option>
        <option value="16px">16</option>
        <option value="18px">18</option>
        <option value="20px">20</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
    </span>
    {/* <span className="ql-formats">
      <button className="ql-script" value="super" />
      <button className="ql-script" value="sub" />
      <button className="ql-blockquote" />
      <button className="ql-direction" />
    </span> */}
    <span className="ql-formats">
      <select className="ql-align" />
      <select className="ql-color" />
      <select className="ql-background" />
    {/* </span>
    <span className="ql-formats">
      <button className="ql-link" /> */}
      <button className="ql-image" />
      {/* <button className="ql-video" /> */}
    </span>
    <span className="ql-formats">
      <button className="ql-formula" />
      <button className="ql-code-block" />
      <button className="ql-clean" />
    </span>
  </div>
);

export default QuillToolbar;